<!-- Posts to display in a blog listing; All posts have a title, description, author(s),
     and an image.
-->

<template>
  <mdb-row>
    <div v-if="loading" class="w-100 position-absolute">
      <mdb-spinner />
    </div>
    <div v-if="!loading && posts && posts.length > 0" class="w-100 animated bounce">
      <div v-for="post in posts" :key="post.id">
        <mdb-row class="mb-5 mt-3">
          <mdb-col md="5">
            <mdb-view class="rounded z-depth-2 mb-lg-0 mb-4" hover>
              <img class="img-fluid" :src="`${post.intro_image.url}`" alt="Sample image" />
              <a>
                <mdb-mask overlay="white-slight" waves />
              </a>
            </mdb-view>
          </mdb-col>
          <mdb-col md="7">
            <h3 class="font-weight-bold mb-3 p-0">
              <strong>{{post.title}}</strong>
            </h3>
            <p style="display: inline;">by </p>
            <p v-for="(author, i) in post.blog_authors" :key="i" style="display: inline;">
              <strong>{{author.author_name}}</strong>
              <strong v-if="(i + 1) != post.blog_authors.length">,</strong>
            </p>
            <p>{{post.description}}</p>
            <router-link
              class="menu-item pl-0"
              :to="'/' + extractType(post.meta.type) + '/' + post.meta.slug"
            >
              <mdb-btn color="primary" class="waves-light" size="sm">Read More</mdb-btn>
            </router-link>
          </mdb-col>
        </mdb-row>
        <hr class="mb-5" />
      </div>
    </div>
    <div v-else-if="!loading && posts && posts.length == 0" class="w-100 animated bounce">
      <h2 class="h1-responsive font-weight-bold text-center my-5">No Posts Found</h2>
    </div>
  </mdb-row>
</template>

<script>
import { mdbRow, mdbCol, mdbMask, mdbView, mdbBtn, mdbSpinner } from "mdbvue";
import axios from "axios";
import api from "@/api"
import _ from "lodash";
import shared from "@/shared";

export default {
  name: "BlogPosts",
  components: {
    mdbRow,
    mdbCol,
    mdbMask,
    mdbView,
    mdbBtn,
    mdbSpinner,
  },
  props: {
    slug: {
      type: [String],
    },
    type: {
      type: [String],
      default: "blog.DepartmentArticleBlogPage",
    },
    descendant_of: {
      type: [Number, Boolean],
    },
    category: {
      type: [Number, Boolean],
    },
    tag: {
      type: [String, Boolean],
    },
    fields: {
      type: [String],
      default: "*",
    },
    search: {
      type: [String],
    },
    offset: {
      type: [Number],
      default: 0,
    },
  },
  data() {
    return {
      loading: true,
      posts: false,
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.getDataDebounced = _.debounce(this.getData, 500);
  },
  computed: {
    axiosParams() {
      const params = new URLSearchParams();
      if (this.descendant_of) {
        params.append("descendant_of", this.descendant_of);
      }
      if (this.category) {
        params.append("categories", this.category);
      }
      if (this.tag) {
        params.append("tags", this.tag);
      }
      params.append("type", this.type);
      params.append("fields", this.fields);
      if (this.search) {
        params.append("search", this.search);
      }
      params.append("order", "-id");
      params.append("limit", "10");
      params.append("offset", this.offset);

      return params;
    },
  },

  methods: {
    getData() {
      this.loading = true;
      axios
        api.get("pages/", {
          params: this.axiosParams
        })
        .then((response) => {
          this.posts = response.data.items;
          var count = response.data.meta.total_count;
          this.$emit("setUpPagination", count);
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => (this.loading = false));
    },
    updateCategory(catNum) {
      this.selectedCategory = catNum;
      this.getData();
    },
    updateTag(tagName) {
      if (tagName == this.selectedTag) {
        this.selectedTag = false;
      } else {
        this.selectedTag = tagName;
      }

      this.getData();
    },
    clearFilters(item) {
      if (item === "tag" || item === "all") {
        this.selectedTag = false;
      }
      if (item === "cat" || item === "all") {
        this.selectedCategory = false;
      }
      this.getData();
    },
    extractType(type) {
      return shared.extractTypeFromWagtailType(type);
    },
  },
  watch: {
    tag: function () {
      // watch it
      this.getData();
    },
    category: function () {
      // watch it
      this.getData();
    },
    descendant_of: function () {
      this.getData();
    },
    search: function () {
      this.getDataDebounced();
    },
    posts: function () {
      this.loading = true;
      process.nextTick(
        function () {
          this.loading = false;
        }.bind(this)
      );
    },
    offset: function () {
      this.getData();
    },
  },
};
</script>

<style scoped>
</style>
